import { useTranslation } from '@mukil/i18n';
import { Badge } from '@jumpstone/ui-react';
import { EMPLOYMENT_TYPE_TONE } from '../../lib/label_keys';
import { employment_type_label } from '../../lib/worker_type_labels';
import type { EmploymentType } from '../../data/types';

/**
 * The single canonical renderer for a worker's type (full-time / part-time /
 * fixed-term / contractor). `employment_type_label` (`lib/worker_type_labels.ts`)
 * and `EMPLOYMENT_TYPE_TONE` (`lib/label_keys.ts`) are the sources of truth; this component is the
 * only place that turns them into a `<Badge>` — the directory (desktop row +
 * phone card), the profile header and the Job tab all import it, per
 * docs/design-system/CLAUDE.md's "One canonical component per status/badge
 * concept". Modelled on `EmploymentStatusBadge`.
 */
export function EmploymentTypeBadge({
  type,
}: {
  type: EmploymentType;
}): React.JSX.Element {
  const { t } = useTranslation('wp');
  return (
    <Badge variant={EMPLOYMENT_TYPE_TONE[type]}>
      {employment_type_label(t, type)}
    </Badge>
  );
}
